import React, { createContext, useState } from "react";
export const RespiratoryInitialContext = createContext({});
const RespiratoryTherapistInitialAssessmentProvider = ({ children }) => {
  const [formData, setFormData] = useState({});
  return (
    <RespiratoryInitialContext.Provider value={{ formData, setFormData }}>
      {children}
    </RespiratoryInitialContext.Provider>
  );
};

export default RespiratoryTherapistInitialAssessmentProvider;
